// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";

import { Headline } from "#/components/headline/Headline";
import { Api } from "#/api";

import Highcharts from "highcharts/highmaps";
import geojson from "./world.geo.json";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class MapModule extends ModuleBase {
  private mapSeriesData = [];

  private colors = ["#0088c6", "#4dc6f4", "#999999"];

  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get isHeadline() {
    return this.instance["section_text"]["headline"]["text"].length > 0;
  }

  get services() {
    return this.instance["section_services"].slice().map((s) => s["service"]);
  }

  public created() {
    this.loadData();
  }

  public loadData() {
    this.services.forEach((s, index) => {
      let id = s["filter"]["FILTER"];
      return this.getFilterData(id, index);
    });
  }

  @Watch("services")
  public onServicesChange() {
    this.loadData();
  }

  @Watch("seriesData")
  public onSeriesDataChange() {
    this.createChart(
      this.seriesData.slice().filter((x) => x && typeof x == "object")
    );
  }

  public createChart(seriesData) {
    let mapEl = this.$refs["map"] as HTMLElement;
    let self = this;
    // @ts-ignore
    let chart = Highcharts.mapChart(mapEl, {
      chart: {
        map: geojson,
        backgroundColor:
          this.backgroundColor == "black" ? "transparent" : "#ffffff",
      },
      credits: {
        enabled: false,
      },
      legend: {
        itemStyle: {
          color: this.backgroundColor == "black" ? "#ffffff" : "#000000",
          cursor: "pointer",
          fontSize: "12px",
          fontWeight: "bold",
          textOverflow: "ellipsis",
        },
        itemHoverStyle: {
          color: this.backgroundColor == "black" ? "#ffffff" : "#000000",
        },
        reversed: true,
      },
      title: {
        text: "",
      },
      mapNavigation: {
        enabled: true,
      },
      tooltip: {
        shared: true,
        formatter: function () {
          // @ts-ignore
          let code = this.point.code2;

          let serieWithName = self.mapSeriesData.find((series) => {
            return series[code];
          });
          let name = "";
          if (serieWithName) {
            name = serieWithName[code]["name"];
          }

          let tooltip = "<b>" + name + "<b><br>";

          let data = self.mapSeriesData
            .map((series, index) => {
              if (series[code] != undefined && series[code]["value"] != 0) {
                return (
                  self.instance["section_services"][index].text +
                  ": " +
                  series[code]["value"]
                );
              }
              return "";
            })
            .join("<br>");

          return tooltip + data;
        },
      },
      series: [
        {
          data: [],
          name: "Basemap",
          showInLegend: false,
        },
        ...seriesData,
      ],
    });
  }

  get seriesData() {
    return this.mapSeriesData
      .map((series, index) => {
        return {
          name: this.instance["section_services"][index].text,
          joinBy: ["iso-a2", "code2"],
          allAreas: false,
          color: this.colors[index],
          data: Object.keys(series).map((key) => {
            return {
              code2: key,
              value: series[key],
            };
          }),
        };
      })
      .reverse();
  }

  public async getFilterData(id: number, index: number) {
    let data = await Api.kpiService.getFilterDataByCountry(id);
    this.$set(this.mapSeriesData, index, data);
  }
}
